import Alpine from "alpinejs";

Alpine.data('variantSelector', () => ({
  selectedOptions: Alpine.store('variant').options,

  get product() {
    return Alpine.store('product');
  },
  get variant() {
    return Alpine.store('variant');
  },
  get variants() {
    return this.product.variants;
  },

  isOptionInStock(optionIndex, optionValue) {
    let currentlySelectedOptions = [...this.selectedOptions];
    currentlySelectedOptions[optionIndex] = optionValue;
    return this.variants.some(
      (variant) =>
        currentlySelectedOptions.every((option, i) => variant.options[i] === option) && variant.stock.available
    );
  },
  init() {
    this.$nextTick(() => {
      this.selectedOptions = [...this.variant.options];
    });

    this.$watch('selectedOptions', (options) => {
      Alpine.store(
        'variant',
        this.variants.find((variant) => options.every((option, i) => variant.options[i] === option))
      );
      this.$dispatch('variant-selector:change', Alpine.store('variant'));
    });
  },
}));